<template v-else>
  <div class="container">
    <div class="row">
      <div class="col text-center text-muted">
        <i class="fas fa-10x mb-5 fa-question-circle"></i>
        <p class="lead">
          Encara res a veure! <br />
          <slot></slot>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vacio",
};
</script>